import { useState } from 'react'

import { meetingApi } from '../api'
import { UpdateAssistContextRequest } from '../api/meetingApiInterfaces'

const useUpdateAssistContext = () => {
  const [isSaving, setIsSaving] = useState(false)

  const updateAssistContext = async (meetingId: string, payload: UpdateAssistContextRequest) => {
    setIsSaving(true)
    try {
      return await meetingApi.updateAssistContext(meetingId, payload)
    } catch (error) {
      console.error('Failed to update assist context', error)
    } finally {
      setIsSaving(false)
    }
  }

  return { isSaving, updateAssistContext }
}

export default useUpdateAssistContext
